import { api } from "./api.js";

/**
 * Warm the tabs the player has not opened yet.
 *
 * The Replay and Friends tabs are both a round trip away from anything already
 * on screen, so opening one costs a visible spinner however fast the server is.
 * Fetching them while the browser is idle turns that into an instant render
 * that revalidates behind itself.
 *
 * Deliberately fire-and-forget: a failed warm-up must never surface, because
 * the screen it was for will simply fetch again when it mounts.
 */
type Warm = () => Promise<unknown>;

const WARM: Warm[] = [
  () => api.replays(),
  () => api.feed(),
  () => api.socialMe(),
];

let warmed = false;

export function warmTabs(): void {
  if (warmed) return;
  warmed = true;
  const run = () => { for (const task of WARM) void task().catch(() => undefined); };
  if (typeof requestIdleCallback === "function") requestIdleCallback(run, { timeout: 3000 });
  else window.setTimeout(run, 1200);
}
